<div
    class="rose-portal-address-autocomplete"
    (input)="onUserInput()"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut()"
    (keydown)="onKeydown($event)"
>
    <clkUiElements-input-text
        [element-id]="elementId"
        [label]="label"
        [placeholder]="placeholder"
        [error-required]="errorRequired"
        [icon-id]="iconId"
        [control]="control"
    />
    @if (suggestions.length) {
        <div #dropdown [id]="elementId + '-suggestions-list'" class="suggestions" role="listbox">
            @for (suggestion of suggestions; track $index) {
                <div
                    class="suggestion"
                    role="option"
                    [id]="elementId + '-suggestion-' + $index"
                    [class.highlighted]="$index === highlightedIndex"
                    [attr.aria-selected]="$index === highlightedIndex"
                    (mousedown)="onSuggestionMouseDown($event)"
                    (click)="onSuggestionClick(suggestion)"
                >
                    <span class="suggestion-main">
                        @for (segment of suggestion.mainSegments; track $index) {
                            @if (segment.matched) {
                                <b>{{ segment.text }}</b>
                            } @else {
                                {{ segment.text }}
                            }
                        }
                    </span>
                    <span class="suggestion-secondary">{{ suggestion.secondaryText }}</span>
                </div>
            }
            <!-- Places API attribution policy: official Google Maps logo, 16-19dp tall -->
            <div class="attribution">
                <img src="/assets/images/google-maps-logo-gray.svg" alt="Google Maps" />
            </div>
        </div>
    }
</div>
